import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    redirect: '/apps',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('router.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/apps',
    component: Layout,
    meta: {
      title: '应用管理',
      icon: 'vscode-icons:file-type-appscript'
    },
    name: 'App',
    children: [
      {
        path: '',
        name: 'AppIndex',
        component: () => import('@/views/App/App.vue'),
        meta: {
          title: '应用列表',
          icon: 'icon-park-solid:more-app'
        }
      }
    ]
  },
  {
    path: '/sendings',
    component: Layout,
    meta: {
      title: '邮件发送',
      icon: 'streamline:send-email-solid'
    },
    name: 'Sending',
    children: [
      {
        path: 'index',
        name: 'SendingIndex',
        component: () => import('@/views/Sending/Sending.vue'),
        meta: {
          title: '发送记录',
          icon: 'icon-park-outline:send-email'
        }
      },
      {
        path: 'notices',
        name: 'SendingNotice',
        component: () => import('@/views/Sending/Sending.vue'),
        meta: {
          title: '通知回调',
          icon: 'icon-park-solid:phone-outgoing-one'
        }
      }
    ]
  },
  {
    path: '/receivings',
    component: Layout,
    meta: {
      title: '邮件收取',
      icon: 'icon-park-solid:inbox'
    },
    name: 'Receiving',
    children: [
      {
        path: 'index',
        name: 'ReceivingIndex',
        component: () => import('@/views/Receiving/Receiving.vue'),
        meta: {
          title: '收取记录',
          icon: 'icon-park-outline:accept-email'
        }
      },
      {
        path: 'notices',
        name: 'ReceivingNotice',
        component: () => import('@/views/Receiving/Receiving.vue'),
        meta: {
          title: '通知回调',
          icon: 'icon-park-solid:phone-outgoing-one'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
